import { useFragment } from '@apollo/client/react';
import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { AddMetadataLabelFragmentFragmentDoc } from './AddMetadataLabelFragment.gql';
import { RemoveSelection } from './RemoveSelection';
export function AddMetadataBooleanSelection(props) {
    const { from } = props;
    const { submitForm } = useFormikContext();
    const [field, , helpers] = useField('value');
    const { data, complete } = useFragment({
        from,
        fragment: AddMetadataLabelFragmentFragmentDoc,
    });
    const handleSelect = (value) => {
        helpers.setValue(value);
        submitForm();
    };
    if (!complete) {
        return null;
    }
    return (<Menu.ItemNested target={data.label}>
      <Menu.Item selected={field.value === true} onClick={() => handleSelect(true)}>
        <Trans comment="Metadata: Add metadata boolean pair - Yes value">Yes</Trans>
      </Menu.Item>
      <Menu.Item selected={field.value === false} onClick={() => handleSelect(false)}>
        <Trans comment="Metadata: Add metadata boolean pair - No value">No</Trans>
      </Menu.Item>
      <RemoveSelection />
    </Menu.ItemNested>);
}
